import { render } from "./ChapterConfirmPopup.vue?vue&type=template&id=f52efefa"
import script from "./ChapterConfirmPopup.vue?vue&type=script&lang=js"
export * from "./ChapterConfirmPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__